const CURRENCIES = require('./currencies')

module.exports = {
  AM: {
    currency: CURRENCIES.AMD.code,
    timeFormat: '24',
    weekStart: 1
  },
  US: {
    currency: CURRENCIES.USD.code,
    timeFormat: '12',
    weekStart: 0
  },
  AU: {
    currency: CURRENCIES.AUD.code,
    timeFormat: '12',
    weekStart: 1
  },
  NZ: {
    currency: CURRENCIES.AUD.code,
    timeFormat: '12',
    weekStart: 1
  },
  UK: {
    currency: CURRENCIES.GBP.code,
    timeFormat: '24',
    weekStart: 1
  },
  CA: {
    currency: CURRENCIES.CAD.code,
    timeFormat: '12',
    weekStart: 0
  },
  JP: {
    currency: CURRENCIES.JPY.code,
    timeFormat: '24',
    weekStart: 0
  },

  PH: {
    currency: CURRENCIES.PHP.code,
    timeFormat: '12',
    weekStart: 0
  },

  default: {
    currency: CURRENCIES.EUR.code,
    timeFormat: '24',
    weekStart: 1
  }
}
